import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';

import { UserNoteVisibility } from 'user/note/user-note-visibiity';

export interface IUserNote extends IEntity {
	readonly note: string;
	readonly targetId: string;
	readonly userId: string;
	readonly visibility: UserNoteVisibility;
}

export class UserNote extends Entity {
	private _note: string;
	private _targetId: string;
	private _userId: string;
	private _visibility: UserNoteVisibility;

	constructor(
		id: string,
		creationTimestamp: number,
		note: string,
		targetId: string,
		userId: string,
		visibility: UserNoteVisibility
	) {
		super(id, creationTimestamp);
		this._note = note;
		this._targetId = targetId;
		this._userId = userId;
		this._visibility = visibility;
	}

	public get note(): string {
		return this._note;
	}

	public get targetId(): string {
		return this._targetId;
	}

	public get userId(): string {
		return this._userId;
	}

	public get visibility(): UserNoteVisibility {
		return this._visibility;
	}
}
